// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1sSS0","title":"ClientReferral_title__1ULzC","itemText":"ClientReferral_itemText__NYc4Z"};